<template>
    <b-form-checkbox-group
        :checked="value || []"
        :options="options"
        stacked
        @input="$emit('input', $event)"
    />
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "CheckboxArrayField" })
export default class CheckboxArrayField extends Vue {
    @Prop({ default: () => [] }) value!: string[];
    @Prop({ type: Array, required: true }) options!: Array<{ text: string; value: string }>;
}
</script>
